import React, { FC } from 'react';
import {PropsWithChildren} from "react";

import * as styles from './additional.module.scss';
import cls from "classnames";

export type AdditionalCardProps = {
    className?: string;
}

export const AdditionalCard = (props: PropsWithChildren<AdditionalCardProps>) => {
    return (
        <div className={cls(styles.container, props.className)}>
            {props.children}
        </div>
    )
}